import { render, staticRenderFns } from "./DispatchingOrderMatching.vue?vue&type=template&id=2cb9ac37&scoped=true"
import script from "./DispatchingOrderMatching.vue?vue&type=script&lang=js"
export * from "./DispatchingOrderMatching.vue?vue&type=script&lang=js"
import style0 from "./DispatchingOrderMatching.vue?vue&type=style&index=0&id=2cb9ac37&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb9ac37",
  null
  
)

export default component.exports